import React from 'react';
import PropTypes from 'prop-types';
import {
  CHALLENGE_TAB,
  CHALLENGE_TABS,
  GAME_TYPE,
} from '../../services/utilityFunctions';
import GameProp from './propTypes/gameProp';
import translate from '../../commonComponents/translate';
import TabbedPortlet from '../../commonComponents/portlets/Tabbed/TabbedPortlet';
import Info from './details/Info';
import Leaderboard from './details/Leaderboard';
import Timeline from './details/Timeline';
import Leads from './details/Leads';
import Recommendations from './details/Recommendations';
import Course from './details/Course';
import AppProductProp from '../profile/propTypes/appProductProp';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import StripeCardProp from '../profile/propTypes/StripeCardProp';
import Performance from './details/Performance';
import CurrencyProp from '../profile/propTypes/currencyProp';
import SkipStepButton from '../journey/overall/content/components/SkipStepButton';

function ChallengeDetails(props) {
  const {
    t,
    challenge,
    cards,
    appProducts,
    countries,
    activeTab,
    onChange,
    pspdfkitLicenseKey,
    _csrf,
    currencies,
    onSkipStep,
  } = props;

  const challengeType = challenge.gameType
    ? challenge.gameType.type
    : GAME_TYPE.PRODUCTIVITY;

  const genericTabs = [
    {
      id: CHALLENGE_TAB.TIMELINE,
      title: t('challengeDetails_tab_timeline'),
      content: <Timeline challengeId={challenge._id} />,
    },
    {
      id: CHALLENGE_TAB.INFO,
      title: t('challengeDetails_tab_info'),
      content: <Info challenge={challenge} />,
    },
  ];

  const statsTab = {
    id: CHALLENGE_TAB.PERFORMANCE,
    title: t('challengeDetails_tab_performance'),
    content: (
      <Performance
        challenge={challenge}
        challengeType={challengeType}
        _csrf={_csrf}
      />
    ),
  };

  const genericAndStatsTabs = [genericTabs[0], statsTab, genericTabs[1]];

  const leaderboardTab = {
    id: CHALLENGE_TAB.LEADERBOARD,
    title: t('challengeDetails_tab_leaderboard'),
    content: <Leaderboard challenge={challenge} currencies={currencies} />,
  };

  const leadsTab = {
    id: CHALLENGE_TAB.LEADS,
    title: t('challengeDetails_tab_leads'),
    content: <Leads challenge={challenge} />,
  };

  const recommendationsTab = {
    id: CHALLENGE_TAB.RECOMMENDATIONS,
    title: t('challengeDetails_tab_recommendations'),
    content: <Recommendations challenge={challenge} />,
  };

  const courseTab = {
    id: CHALLENGE_TAB.COURSE,
    title: t('challengeDetails_tab_course'),
    content: (
      <Course
        challenge={challenge}
        cards={cards}
        appProducts={appProducts}
        countries={countries}
        onChange={onChange}
        pspdfkitLicenseKey={pspdfkitLicenseKey}
      />
    ),
  };

  const tabConfig = (type => {
    switch (type) {
      case GAME_TYPE.PRODUCTIVITY:
        return [leaderboardTab].concat(genericAndStatsTabs);
      case GAME_TYPE.CROSS_SELLING:
        return [leadsTab, leaderboardTab].concat(genericAndStatsTabs);
      case GAME_TYPE.CANDIDATES:
        return [recommendationsTab].concat(genericTabs);
      case GAME_TYPE.E_LEARNING:
        return [courseTab].concat(genericTabs);
      case GAME_TYPE.PROFILING:
      default:
        return genericTabs;
    }
  })(challengeType);
  const expectedTab = tabConfig.findIndex(tab => tab.id === activeTab);
  const selectedIndex = expectedTab !== -1 ? expectedTab : 0;

  return (
    <TabbedPortlet
      tabs={tabConfig}
      selectedIndex={selectedIndex}
      isFullHeight={false}
      onSkipStep={onSkipStep}
      actions={
        <>
          {onSkipStep && (
            <div className="skip-wrapper m-0">
              <SkipStepButton onClick={onSkipStep} />
            </div>
          )}
        </>
      }
    />
  );
}

ChallengeDetails.propTypes = {
  t: PropTypes.func.isRequired,
  challenge: PropTypes.shape(GameProp.propType).isRequired,
  activeTab: PropTypes.oneOf(CHALLENGE_TABS).isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(StripeCardProp.propType)).isRequired,
  onChange: PropTypes.func,
  appProducts: PropTypes.arrayOf(PropTypes.shape(AppProductProp.propType))
    .isRequired,
  _csrf: PropTypes.string.isRequired,
  pspdfkitLicenseKey: PropTypes.string,
  onSkipStep: PropTypes.func,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType))
    .isRequired,
};

ChallengeDetails.defaultProps = {
  onChange: null,
  pspdfkitLicenseKey: null,
  onSkipStep: null,
};

export default translate(ChallengeDetails);
